import { RemoteAdminData } from 'app/infrastructure/remote-data';
import { endpoints } from './endpoints';
import { OperationsItemWire } from './types';
import { ApiResponse, Value } from 'app/types-shared';

export const api = {

  loadOperationsList: async (): Promise<OperationsItemWire[]> => {

    const response = await new RemoteAdminData(endpoints.loadOperationsList)
      .resource<ApiResponse<OperationsItemWire[]>>()
      .single();

    return response.data;
  },

  updateOperations: async (list: Value[]): Promise<Value[]> => {
    await new RemoteAdminData(endpoints.updateOperations)
      .resource<void>()
      .save(list);

    return list;
  }
};
